import React from 'react';
import {
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
  Box,
  useTheme,
} from '@mui/material';

const RegimenFilter = ({
  regimenList,
  selectedRegimen,
  handleRegimenChange,
  convertToCamelCase,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Typography sx={{ fontSize: '17px', fontWeight: 600, color: 'black' }}>
        Régimen de comida
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
        <FormControlLabel
          value="allOptions"
          onClick={() => handleRegimenChange('allOptions')}
          control={
            <Checkbox
              checked={selectedRegimen === 'allOptions'}
              sx={{
                color: theme?.primary,
                '&.Mui-checked': { color: theme?.primary },
              }}
            />
          }
          label="Todas las opciones"
          sx={{ mb: 1 }}
        />

        {regimenList.map(
          (reg, index) =>
            reg.state && (
              <FormControlLabel
                key={reg.type + index}
                value={reg.type}
                onClick={() => handleRegimenChange(reg.type)}
                control={
                  <Checkbox
                    checked={selectedRegimen === reg.type}
                    sx={{
                      color: theme?.primary,
                      '&.Mui-checked': { color: theme?.primary },
                    }}
                  />
                }
                label={convertToCamelCase(reg.type)}
                sx={{ mb: 1 }}
              />
            )
        )}
      </Box>

      <Divider sx={{ mt: 1 }} />
    </Box>
  );
};

export default RegimenFilter;
